// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insecure_registry[data-v-3580ef03]{background-color:var(--el-color-primary-light-9);margin-bottom:10px;padding:0 10px 0 0}.insecure_registry .header[data-v-3580ef03]{background-color:var(--el-color-primary-light-3);color:#fff;padding:0 10px;margin-bottom:10px;margin-right:-10px}.description[data-v-3580ef03]{color:var(--el-color-text-secondary);line-height:24px;padding:10px;background-color:var(--el-color-info-light-9)}", ""]);
// Exports
module.exports = exports;
